module.exports = __webpack_public_path__ + "media/images/lb/692-a6851519feb66fef6f0b3b46ea27b13b.svg";